/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesGroupType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesGroupType = typeof WebApiModelsEnumerationTypesGroupType[keyof typeof WebApiModelsEnumerationTypesGroupType];


export function WebApiModelsEnumerationTypesGroupTypeFromJSON(json: any): WebApiModelsEnumerationTypesGroupType {
    return WebApiModelsEnumerationTypesGroupTypeFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesGroupTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesGroupType {
    return json as WebApiModelsEnumerationTypesGroupType;
}

export function WebApiModelsEnumerationTypesGroupTypeToJSON(value?: WebApiModelsEnumerationTypesGroupType | null): any {
    return value as any;
}

